export default "__VITE_ASSET__DhNNX6$O__"